"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("./..");

var _reactDayPicker = _interopRequireWildcard(require("react-day-picker"));

var _moment = _interopRequireDefault(require("moment"));

require("moment/locale/es");

var _moment2 = _interopRequireDefault(require("react-day-picker/moment"));

var _utils = require("../../../utils");

var addDayToRange = function addDayToRange(day, value) {
  if (!value) {
    return {
      from: day,
      to: null
    };
  } else {
    var from = value.from,
        to = value.to;

    if (from && to) {
      return {
        from: day,
        to: null
      };
    } else if (from) {
      if (_reactDayPicker.DateUtils.isDayBefore(day, from)) {
        return {
          from: day,
          to: from
        };
      }

      return {
        from: from,
        to: day
      };
    } else {
      return {
        from: day,
        to: null
      };
    }
  }
};

function YearMonthSelector(_ref) {
  var date = _ref.date,
      fromMonth = _ref.fromMonth,
      toMonth = _ref.toMonth,
      localeUtils = _ref.localeUtils,
      locale = _ref.locale,
      onMonthChange = _ref.onMonthChange;
  var yearMonth = {
    year: date.getFullYear(),
    month: date.getMonth().toString()
  };
  var fromDate = fromMonth || (0, _moment.default)(date).add('year', -10).toDate();
  var toDate = toMonth || (0, _moment.default)(date).add('year', 10).toDate();
  var months = (0, _react.useMemo)(function () {
    return localeUtils.getMonths(locale);
  }, [locale, localeUtils]);
  var yearOptions = (0, _react.useMemo)(function () {
    var fromYear = fromDate.getFullYear();
    var toYear = toDate.getFullYear();
    var years = [];

    for (var i = fromYear; i <= toYear; i += 1) {
      years.push(i);
    }

    return years.map(function (year, i) {
      return {
        label: year,
        value: year
      };
    });
  }, [fromDate, toDate]);
  var monthOptions = (0, _react.useMemo)(function () {
    return months.map(function (month, i) {
      return {
        label: month,
        value: i.toString(),
        disabled: !_reactDayPicker.DateUtils.isDayBetween((0, _moment.default)({
          year: yearMonth.year,
          month: i
        }).endOf('month').toDate(), (0, _moment.default)(fromDate).startOf('month').toDate(), (0, _moment.default)(toDate).endOf('month').toDate()) && !_reactDayPicker.DateUtils.isDayBetween((0, _moment.default)({
          year: yearMonth.year,
          month: i
        }).startOf('month').toDate(), (0, _moment.default)(fromDate).startOf('month').toDate(), (0, _moment.default)(toDate).endOf('month').toDate())
      };
    });
  }, [fromDate, months, toDate, yearMonth.year]);
  var handleMonthChange = (0, _react.useCallback)(function (month) {
    onMonthChange(new Date(yearMonth.year, month));
  }, [onMonthChange, yearMonth.year]);
  var handleYearChange = (0, _react.useCallback)(function (year) {
    onMonthChange(new Date(year, yearMonth.month));
  }, [onMonthChange, yearMonth.month]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "DayPicker-Caption"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "DayPicker-DateSelectors"
  }, /*#__PURE__*/_react.default.createElement(_.SelectField, {
    variant: "outline",
    className: "SelectField_year",
    name: "year",
    onChange: handleYearChange,
    value: yearMonth.year,
    options: yearOptions
  }), /*#__PURE__*/_react.default.createElement(_.SelectField, {
    variant: "outline",
    className: "SelectField_month",
    name: "month",
    value: yearMonth.month,
    onChange: handleMonthChange,
    options: monthOptions
  })));
}

YearMonthSelector.propTypes = {
  /** The currently displayed month */
  date: _propTypes.default.instanceOf(Date),

  /** The localeUtils object passed to the component. */
  localeUtils: _propTypes.default.object,

  /** The current locale passed to the component. */
  locale: _propTypes.default.string,

  /** Callback fire when change month. */
  onMonthChange: _propTypes.default.func,

  /** Callback fire when change month. */
  fromMonth: _propTypes.default.instanceOf(Date),

  /** Callback fire when change month. */
  toMonth: _propTypes.default.instanceOf(Date)
};
YearMonthSelector.displayName = 'YearMonthSelector';

var DayPicker = function DayPicker(props) {
  var alias = props.alias,
      multiple = props.multiple,
      interval = props.interval,
      value = props.value,
      onChange = props.onChange,
      showDateSelectors = props.showDateSelectors,
      onMonthChange = props.onMonthChange,
      initialMonth = props.initialMonth,
      fromMonth = props.fromMonth,
      toMonth = props.toMonth,
      locale = props.locale,
      modifiers = props.modifiers,
      restProps = (0, _objectWithoutPropertiesLoose2.default)(props, ["alias", "multiple", "interval", "value", "onChange", "showDateSelectors", "onMonthChange", "initialMonth", "fromMonth", "toMonth", "locale", "modifiers"]);

  var _useState = (0, _react.useState)(),
      enteredTo = _useState[0],
      setEnteredTo = _useState[1];

  var selectedDays = (0, _react.useMemo)(function () {
    if (value) {
      return value;
    } else if (multiple) {
      return [];
    } else if (interval) {
      return {};
    } else {
      return null;
    }
  }, [interval, multiple, value]);
  var firstDate = (0, _react.useMemo)(function () {
    if (multiple) {
      return selectedDays[0];
    } else if (interval) {
      return selectedDays.from;
    } else {
      return selectedDays;
    }
  }, [interval, multiple, selectedDays]);

  var _useState2 = (0, _react.useState)(initialMonth || firstDate),
      selectedMonth = _useState2[0],
      selectMonth = _useState2[1];
  /** Callback fired when a day is clicked */


  var onDayClick = (0, _react.useCallback)(function (day, _ref2, e) {
    var selected = _ref2.selected,
        disabled = _ref2.disabled;

    /** TODO: Allow prevent or not changes if day disabled */
    if (disabled) {
      return;
    }

    if (multiple) {
      if (selected) {
        var selectedIndex = selectedDays.findIndex(function (selectedDay) {
          return _reactDayPicker.DateUtils.isSameDay(selectedDay, day);
        });
        selectedDays.splice(selectedIndex, 1);
        onChange([].concat(selectedDays.slice(0, selectedIndex), selectedIndex(selectedIndex + 1)), e);
      } else {
        onChange([].concat(selectedDays, [day]), e);
      }
    } else if (interval) {
      setEnteredTo(null);
      onChange(addDayToRange(day, selectedDays), e);
    } else {
      onChange(selected ? undefined : day, e);
    }
  }, [interval, multiple, onChange, selectedDays]);
  var handleMouseEnter = (0, _react.useCallback)(function (day) {
    if (interval) {
      var from = selectedDays.from,
          to = selectedDays.to;

      if (from && !to) {
        setEnteredTo(day);
      }
    }
  }, [interval, selectedDays]);
  var handleMouseLeave = (0, _react.useCallback)(function () {
    setEnteredTo(null);
  }, [setEnteredTo]);
  /** Callback fired when a change month */

  var changeMonth = (0, _react.useCallback)(function (date) {
    if (showDateSelectors) {
      selectMonth(date);
    }

    if (onMonthChange) {
      onMonthChange(date);
    }
  }, [onMonthChange, showDateSelectors]);
  /** Custom day picker props */

  var dayPickerProps = (0, _react.useMemo)(function () {
    var pickerProps = {
      locale: locale,
      toMonth: toMonth,
      fromMonth: fromMonth,
      month: selectedMonth,
      onMonthChange: changeMonth,
      localeUtils: _moment2.default,
      initialMonth: initialMonth || firstDate || new Date()
    };
    /** If showDateSelectos, a Caption element is added to DayPicker props */

    if (showDateSelectors) {
      var CaptionElement = function CaptionElement(props) {
        return /*#__PURE__*/_react.default.createElement(YearMonthSelector, (0, _extends2.default)({}, props, {
          locale: locale,
          toMonth: toMonth,
          fromMonth: fromMonth,
          onMonthChange: changeMonth
        }));
      };

      CaptionElement.displayName = 'CaptionElement';
      pickerProps.captionElement = CaptionElement;
    }

    return pickerProps;
  }, [locale, toMonth, selectedMonth, fromMonth, changeMonth, initialMonth, firstDate, showDateSelectors]);
  var rangeSelectedDays = interval && (0, _extends2.default)({}, selectedDays, {
    to: enteredTo || selectedDays.to
  }) || selectedDays;
  var rangeModifiers = (0, _react.useMemo)(function () {
    if (interval) {
      if (selectedDays) {
        var from = selectedDays.from;
        var to = enteredTo || selectedDays.to;

        if (from && to) {
          if (_reactDayPicker.DateUtils.isDayBefore(to, from)) {
            return {
              end: from,
              start: to
            };
          } else {
            return {
              end: to,
              start: from
            };
          }
        }
      } else {
        return {
          start: selectedDays.from,
          end: selectedDays.to
        };
      }
    }

    return {};
  }, [enteredTo, interval, selectedDays]);
  var localModifiers = (0, _extends2.default)({}, rangeModifiers, modifiers);
  return /*#__PURE__*/_react.default.createElement(_reactDayPicker.default, (0, _extends2.default)({
    selectedDays: rangeSelectedDays,
    onDayClick: onDayClick,
    onDayMouseEnter: handleMouseEnter,
    onDayMouseLeave: handleMouseLeave,
    modifiers: localModifiers
  }, dayPickerProps, restProps));
};

DayPicker.propTypes = {
  /** It describes a standalone entity that is meaningful on its own. It will be used to generate the component className. */
  alias: _propTypes.default.string,

  /** It extends component styles. */
  className: _propTypes.default.string,

  /** Selected day or days. It can be one of the following types:
   - __String__ Formated date string, ie: 'YYYY-MM-DD'. Require set format prop.
   - __Date__ An instance of Date.
   - __Array__ An array of formatted date strings or instances of Date. Require set __multiple__ prop to true.
   - __Object__ An object with from to props as formatted date string or instances of Date. Require set __interval__ prop to true. */
  value: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _propTypes.default.shape({
    from: _propTypes.default.instanceOf(Date),
    to: _propTypes.default.instanceOf(Date)
  }), _propTypes.default.arrayOf(_propTypes.default.instanceOf(Date))]),

  /** Callback function fired when day picker value change */
  onChange: _propTypes.default.func,

  /** Callback function fired when month change */
  onMonthChange: _propTypes.default.func,

  /** If true, DayPicker allow pick an interval of dates. */
  interval: _propTypes.default.bool,

  /** If true, DayPicker allow pick multiple dates. */
  multiple: _propTypes.default.bool,

  /** If true, DayPicker render yaer and month selectors as Caption. */
  showDateSelectors: _propTypes.default.bool,

  /** Date locale */
  locale: _propTypes.default.string,

  /** The month to display in the calendar at first render. it won’t re-render the calendar if its value changes. */
  initialMonth: _propTypes.default.instanceOf(Date),

  /** The first allowed month. Users won’t be able to navigate or interact with the days before it. */
  fromMonth: _propTypes.default.instanceOf(Date),

  /** The last allowed month. Users won’t be able to navigate or interact with the days before it. */
  toMonth: _propTypes.default.instanceOf(Date),

  /** An object of day modifiers. See [matching days](http://react-day-picker.js.org/docs/matching-days). */
  modifiers: _propTypes.default.object
};
DayPicker.defaultProps = {
  alias: 'DayPicker',
  showDateSelectors: false,
  onChange: _utils.noop,
  locale: 'es'
};
DayPicker.displayName = 'DayPicker';
var _default = DayPicker;
exports.default = _default;